module.exports = __webpack_public_path__ + "img/icon_no_wc.a277c345.png";